import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindProductsCatalogRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindProductsCatalogRequestSortsDto
  setSorts: Dispatch<SetStateAction<FindProductsCatalogRequestSortsDto>>
}

export const ProductsCatalogSorts = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("products")

  return (
    <SortBuilder<FindProductsCatalogRequestSortsDto>
      sorts={sorts}
      setSorts={setSorts}
      options={[
        { label: t("sorts.name"), value: "name" },
        { label: t("sorts.brandReference"), value: "brandReference" },
        { label: t("sorts.purchaseOrder"), value: "purchaseOrder" },
        { label: t("sorts.brand"), value: "brand" },
        { label: t("sorts.color"), value: "color" },
        { label: t("sorts.brandType"), value: "brandType" },
        { label: t("sorts.collection"), value: "collection" },
        { label: t("sorts.directSupplier"), value: "directSupplier" },
        { label: t("sorts.ingestionDate"), value: "ingestionDate" },
      ]}
    />
  )
}
